// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-reward-list .highest-reward {
  font-weight: bold;
}
.quiz-reward-list .reward-list {
  max-height: 0;
  display: block;
  overflow: hidden;
}
.quiz-reward-list .show-reward-list {
  transition: 600ms;
  max-height: 400px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/quiz-reward-list/quiz-reward-list.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAGI;EACI,aAAA;EACA,cAAA;EACA,gBAAA;AADR;AAII;EACI,iBAAA;EACA,iBAAA;AAFR","sourcesContent":[".quiz-reward-list {\n    .highest-reward {\n        font-weight: bold;\n    }\n\n    .reward-list {\n        max-height: 0;\n        display: block;\n        overflow: hidden;\n    }\n\n    .show-reward-list {\n        transition: 600ms;\n        max-height: 400px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
